// Global
import { tv } from 'tailwind-variants';

export type SkeletonFilterPanelProps = {
  filterCount?: number;
};

const SkeletonFilterPanel = ({ filterCount = 2 }: SkeletonFilterPanelProps) => {
  const { panel, label, filterRow, filterBox } = TAILWIND_VARIANTS({
    filterCount: filterCount as 1 | 2 | 3,
  });

  return (
    <div className={panel()}>
      {/* Filter label skeleton */}
      <div className={label()} />

      {/* Filter dropdowns skeleton */}
      <div className={filterRow()}>
        {[...Array(filterCount)].map((_, index) => (
          <div key={index} className={filterBox()} />
        ))}
      </div>
    </div>
  );
};

export default SkeletonFilterPanel;

const TAILWIND_VARIANTS = tv({
  slots: {
    panel: [
      'flex',
      'flex-col',
      'p-spacing-spacing-16',
      'gap-spacing-spacing-16',
      'self-stretch',
      'rounded-border-radius-radius-4',
      'bg-color-bg-white',
      'shadow-[0_0_8px_0_var(--color-black-alpha-10)]',
    ],
    label: ['h-6', 'w-48', 'bg-gray-300', 'rounded', 'animate-pulse'],
    filterRow: ['grid', 'grid-cols-1', 'gap-x-space-between-less', 'gap-y-spacing-spacing-16'],
    filterBox: ['h-12', 'bg-gray-300', 'rounded-general-border-radius-button', 'animate-pulse'],
  },
  variants: {
    filterCount: {
      1: {
        filterRow: ['lg:grid-cols-1'],
      },
      2: {
        filterRow: ['lg:grid-cols-2'],
      },
      3: {
        filterRow: ['lg:grid-cols-3'],
      },
    },
  },
});
